import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { DeviceLoginBaseEffect } from './device-login-base.effect';

@NgModule({
  imports: [ EffectsModule.forFeature([ DeviceLoginBaseEffect ]) ]
})
export class DeviceLoginBaseModule {}
